import { useCallback, useState } from "react";

export function useAsyncFilter(initialTerm: string): [string, (expr) => Promise<void>] {
  const [filterTerm, setFilterTerm] = useState<string>(initialTerm);

  const searchExprChanged = useCallback((expr: string) => {
    return new Promise<void>((resolve) => {
      setFilterTerm(expr);
      resolve();
    });
  }, []);

  return [filterTerm, searchExprChanged];
}
